import { render, staticRenderFns } from "./PaperManage.vue?vue&type=template&id=4b7a565d&scoped=true"
import script from "./PaperManage.vue?vue&type=script&lang=js"
export * from "./PaperManage.vue?vue&type=script&lang=js"
import style0 from "./PaperManage.vue?vue&type=style&index=0&id=4b7a565d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7a565d",
  null
  
)

export default component.exports